import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

const Cross = (props) => {
  return (
    <span class={`${props.masterClasses || ''}`} title={props.title || ''}>
      <svg title={props.title || ""} onclick={(e) => props.action && props.action(e)} class={props.classes || ""} xmlns="http://www.w3.org/2000/svg" version="1.1" id="Capa_1" x="0px"
        y="0px" idth={props.width || "490pt"} height={props.height || "490pt"} viewBox={props.viewBox || "0 0 490 490"} style={`enable-background:new 0 0 490 490; ${props.style || ''}`} fill={props.fill || ''}
      >
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={props.fill || ''} stroke={props.stroke || 'none'} >
          <path d="M161 5103 c-88 -31 -161 -136 -161 -233 0 -20 7 -59 16 -86 15 -45 106 -139 1103 -1137 l1086 -1087 -1082 -1083 c-594 -595 -1089 -1097 -1098 -1116 -45 -90 -24 -213 50 -286 69 -70 163 -91 261 -59 45 15 139 106 1136 1103 l1088 1086 1088 -1086 c997 -997 1091 -1088 1136 -1103 98 -32 192 -11 261 59 70 69 91 163 59 261 -15 45 -106 139 -1103 1137 l-1086 1087 1086 1088 c997 997 1088 1091 1103 1136 32 98 11 192 -59 261 -69 70 -163 91 -261 59 -45 -15 -139 -106 -1137 -1103 l-1087 -1086 -1088 1086 c-997 997 -1091 1088 -1136 1103 -61 20 -117 19 -175 -1z" />
        </g>
      </svg>
    </span>
  );
};

export default Cross;
